import Axios from 'axios';
import { createStandardResponse, StandardResponse } from '../../models/standard-response';
import type { IAboutUsData } from 'models/about-us';
import { env } from 'config/env';

export const getAboutUsData = async (): Promise<StandardResponse<IAboutUsData>> => {
  try {
    const res = await Axios.get(`${env.VITE_API_SERVER}/common/driver/public/information/about-us`);
    return createStandardResponse<IAboutUsData>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};
